module.exports = __webpack_public_path__ + "static/media/banesco-checkmark.da86a0ec.svg";